import { Plus } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { NoteLog } from "@/components/NoteLog";
import { ClientGeneralCard } from "@/pages/clients/sections/ClientGeneralCard";
import { ClientSitesCard } from "@/pages/clients/sections/ClientSitesCard";
import { ClientDirectoryCard } from "@/pages/clients/sections/ClientDirectoryCard";
import { ClientRevenueCard } from "@/pages/clients/sections/ClientRevenueCard";
import { FieldAccessNotesCard } from "@/pages/clients/sections/FieldAccessNotesCard";

// Customer "Info" tab — General · Sites / Directory · Revenue cards, Notes card full width (WO Info-tab pattern).
export function ClientGeneralTab({ general, sites, directory, revenue, notes }) {
  return (
    <TabsContent value="general" className="mt-4 space-y-4" data-testid="client-tab-general">
      <div className="grid grid-cols-1 gap-4 items-stretch lg:grid-cols-[1.1fr_0.9fr]">
        <ClientGeneralCard {...general} />
        <ClientSitesCard {...sites} />
        <ClientDirectoryCard {...directory} />
        <ClientRevenueCard {...revenue} />
      </div>
      <section className="rounded-xl border bg-card p-4 space-y-3" data-testid="client-notes-card">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-semibold text-slate-900">Notes</h3>
          {!notes.isAddingNote && (
            <button type="button" onClick={() => notes.setIsAddingNote(true)} title="Add a note" data-testid="btn-header-add-note"
              className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-emerald-600 text-white hover:bg-emerald-700">
              <Plus className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
        <NoteLog
          notes={Array.isArray(notes.notes) ? notes.notes : []}
          onChange={notes.onChange}
          isAddingExternal={notes.isAddingNote}
          onAddingChange={notes.setIsAddingNote}
          maxVisible={5}
          onArchive={notes.onArchive}
        />
      </section>
      <FieldAccessNotesCard clientId={general.selectedClient?.id} clientName={general.selectedClient?.name || ""} sites={sites.clientSites || []} />
    </TabsContent>
  );
}
